import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { ENUMS, getColumnSearch, getColumnSearchOption, geti18nText, NyDataTable, NySession } from '@nybble/nyreact';
import { CONSTANTS_REQ } from '../../utils/Constants';
import { getDefaultTableParams, setToSession } from '../../utils/Utils';
import CompanyEdit from './edit';

const CompanyIndex = (props: any) => {
    const setDefaultFilterValue = () => {
        return [{ field: 'active', condition: 'equals_bool', value: 1 }];
    };

    return (
        <NyDataTable
            url={CONSTANTS_REQ.COMPANY.LIST}
            headerTitle={geti18nText('company.table.header')}
            addNewButtonText={geti18nText('company.table.add')}
            buttonsClassName={'buttons-sticky'}
            setDefaultFilterValue={setDefaultFilterValue}
            showRecordModal={true}
            modalComponent={CompanyEdit}
            scroll={{ y: 10000, x: 800 }}
            columns={[
                {
                    title: geti18nText('company.table.column.id'),
                    dataIndex: 'id',
                    width: '10%',
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('number'),
                },
                {
                    title: geti18nText('company.table.column.name'),
                    dataIndex: 'name',
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('company.table.column.active'),
                    dataIndex: 'active',
                    width: '10%',
                    render: (text: any, record: { active: any }) => {
                        if (record.active) {
                            return <CheckOutlined style={{ color: 'green' }} />;
                        } else {
                            return <CloseOutlined style={{ color: 'red' }} />;
                        }
                    },
                    ...getColumnSearchOption(ENUMS.ACTIVE(), 'equals_bool', setDefaultFilterValue()[0]['value']),
                    defaultFilteredValue: setDefaultFilterValue(),
                },
            ]}
            onDataLoaded={(data, params) => {
                setToSession(props.tableIndex ? props.tableIndex : 'tableIndex.companies', JSON.stringify(params));
            }}
            {...getDefaultTableParams(props.tableIndex ? props.tableIndex : 'tableIndex.companies')}
        />
    );
};

export default CompanyIndex;
